import { render, staticRenderFns } from "./bankreval.vue?vue&type=template&id=44dc521f"
import script from "./bankreval.vue?vue&type=script&lang=js"
export * from "./bankreval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports